<span style="display: inline-block;">
    <input #itemSearch type="text" placeholder="Search by SKU or device name" [(ngModel)]="query">
    <!-- <input type="checkbox" *ngIf="showAuditCheckbox()" class="audit-checkbox"> -->
    <div *ngIf="active" class="results">
    
        <div class="result" *ngIf="!results.length && !searching">No matches found.</div>
        
        <div class="result" *ngIf="searching">...</div>
        
        <div class="result" *ngFor="let result of results" (click)="selectResult(result)">
            {{ result.description + ' (' + result.sku + ')' }}
        </div>
    </div>
</span>